import gql from "graphql-tag";

export const animal = gql`
  fragment animal on Animal {
    id
    animalBreeds {
      id
      name
      breedrCode
      newClassification
    }
    currentWeight
    dateMovedToFarm
    dob
    eId
    growthRate
    isCastrated
    isMale
    isPregnant
    lastWeight {
      date
      value
    }
    lastRegulatorySyncedDate
    group {
      id
      name
    }
    field {
      id
      name
      location {
        unitName
      }
    }
    passportNumber
    performanceCategory
    pregnancyDueDate
    sexClassification {
      slug
      title
    }
    targetLiveWeight
    visualId
    isRegulatorySynced
    deliveryDate
    withdrawalEnd
    dateLeftFarm
    deadAt
    tags {
      color
      name
      tagId
      schema {
        ownership
      }
    }
  }
`;
